"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

// flow
var MobileScreen = function MobileScreen(_ref) {
  var children = _ref.children;
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    function handleOnResize() {
      var target = ref.current;

      if (target) {
        target.style.setProperty('height', "".concat(window.innerHeight, "px"));
      }
    }

    handleOnResize();
    window.addEventListener('resize', handleOnResize);
    return function () {
      window.removeEventListener('resize', handleOnResize);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "h-screen"
  }, children);
};

var _default = MobileScreen;
exports["default"] = _default;
//# sourceMappingURL=index.js.map